import { TAssetTypeSubTypeItem } from '@interfaces/assets/asset';

export function convertAssetTypesArrayToObject(array: TAssetTypeSubTypeItem[]): Record<string, TAssetTypeSubTypeItem> {
	return array.reduce<Record<string, TAssetTypeSubTypeItem>>((acc, item) => {
		acc[item.type.id] = item;

		return acc;
	}, {});
}
